import config from '@/api/config'

let subUrl = '/order'
let subIiko = '/order/check/iiko'
let pincodeCheck = '/order/check/pincode'

export default {
    createOrder: {
        url: function() {
            return config.baseUrl + config.version2 + subUrl
        }
    },
    createCheckIiko: {
        url: function() {
            return config.baseUrl + config.version2 + subIiko
        }
    },
    createCheckPincode: {
        url: function() {
            return config.baseUrl + config.version2 + pincodeCheck
        }
    }
}